import React from 'react';

interface Props {
    className?: string;
}

const ArrowIcon: React.FC<Props> = ({ className }) => {
    /* eslint-disable max-len */
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m12 9.414-6.293 6.293a1 1 0 1 1-1.414-1.414l6.646-6.647a1.5 1.5 0 0 1 2.122 0l6.646 6.647a1 1 0 0 1-1.414 1.414L12 9.414Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowIcon;
